import api from "./api";

export default {
  listar() {
    return api.get("/cores");
  },
  criar(dados) {
    return api.post("/cores", { cor: dados });
  },
  atualizar(id, dados) {
    return api.put(`/cores/${id}`, { cor: dados });
  },
  excluir(id) {
    return api.delete(`/cores/${id}`);
  },
};
